import styled from 'styled-components';
import { breakpoints, css } from '../../../styles/theme';
import { OrderPanelTemplate } from './OrderPanelTemplate';
import { rem } from 'polished';

export const PriceCss = css`
    display: flex;
    justify-content: space-between;
    width: 95%;

    .calculator {
        display: flex;
        align-items: center;
        cursor: pointer;
        background: none;
        border: none;

        &:focus-visible {
            .txt {
                color: ${({ theme }) => theme.colors.primary};

                span {
                    border-color: ${({ theme }) => theme.colors.primary};
                }
            }
        }

        @media screen and (max-width: ${breakpoints.lg}px) {
            display: none;
        }

        .calculatorIcon {
            height: auto;

            svg {
                width: ${rem('32px')};
                height: ${rem('32px')};
            }
        }

        .txt {
            white-space: nowrap;
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            display: flex;
            flex-direction: column;

            span {
                border-bottom: ${rem('1px')} solid black;
                width: fit-content;
                line-height: ${rem('16px')};
            }

            &:hover {
                color: ${({ theme }) => theme.colors.primary};

                span {
                    border-color: ${({ theme }) => theme.colors.primary};
                }
            }
        }
    }

    .content {
        display: flex;
        flex-direction: column;
        font-family: ${({ theme }) => theme.fonts.fontBase};
        align-items: flex-start;

        .header {
            display: flex;
            font-size: ${rem('8px')};
            width: 100%;
            text-align: left;

            .divider {
                margin-left: ${rem('8px')};
                margin-right: ${rem('8px')};
            }

            .heading {
                font-weight: bold;
            }

            @media screen and (max-width: ${breakpoints.sm}px) {
                .formatMoney,
                .catalogPrice {
                    white-space: nowrap;
                }
            }

            @media screen and (min-width: ${breakpoints.sm}px) {
                white-space: nowrap;
            }
        }

        .body {
            display: flex;
            align-items: baseline;
            margin-top: ${rem('4px')};
            margin-bottom: ${rem('4px')};

            .body-wrapper {
                display: flex;

                .price {
                    min-width: fit-content;
                    font-size: ${rem('14px')};
                    font-weight: bold;

                    .priceOtr {
                        font-size: ${rem('10px')};
                        margin-left: ${rem('6px')};
                        font-weight: bold;
                    }
                }

                .isShowPriceExcludedVAT-price {
                    margin-left: 10px;
                }

                .currencyLabel__suffix--PM {
                    font-size: ${rem('10px')};
                    line-height: 1.5;
                }

                .or {
                    font-size: ${({ theme }) => theme.fontSizes.textBase};
                    margin-left: ${rem('8px')};
                    margin-right: ${rem('8px')};
                    text-transform: lowercase;
                    max-width: ${rem(50)};
                }

                .prefix {
                    font-weight: bold;
                    margin-right: ${rem(8)};
                    white-space: nowrap;
                }

                .infoIcon {
                    display: inline-block;

                    .icon-wrapper {
                        padding-top: ${rem(4)};
                    }

                    .vertical {
                        margin: 0 0 0 0;
                    }

                    svg {
                        width: ${rem('16px')};
                        height: ${rem('16px')};
                        circle,
                        line {
                            stroke: ${({ theme }) => theme.colors.primary};
                        }
                    }
                }
            }

            .totalMonthlyPriceWrapper {
                display: flex;
                align-items: flex-start;
            }

            .footer {
                margin-top: ${rem('5px')};
                font-size: ${rem('8px')};
                display: flex;
                flex-direction: column;
                text-align: left;
                max-width: ${rem('180px')};

                .promotionalTextWrapper,
                .apr {
                    display: flex;
                    flex-direction: column;
                }

                .apr p {
                    font-size: 10px;
                    margin: 0 0 5px;
                }

                .financeContainer-price-financeQuoteLink {
                    cursor: pointer;
                    border-bottom: 1px solid;
                }
            }

            .footer-icon-displayed {
                margin-top: unset;
            }
        }
    }

    @media screen and (max-width: ${breakpoints.md}px) {
        .calculator {
            display: none;
        }
    }
`;

export const OrderPanelStyled = styled(OrderPanelTemplate)`
    background: ${({ theme }) => theme.colors.grey7};
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 999;
    width: 100%;

    &.isShowPriceExcludedVAT-panel {
        .currencyLabel__suffix--OTR {
            font-size: ${rem('8px')};
        }
    }

    @media (min-width: ${breakpoints.md}px) {
        position: sticky;
        top: ${({ isUserLoggedInAsDealer }) => (isUserLoggedInAsDealer ? rem(36) : 0)};
    }

    .wrapper {
        display: flex;
        justify-content: space-between;
        padding: ${rem(20)} 0;
        height: 100%;

        @media screen and (max-width: ${breakpoints.sm}px) {
            flex-direction: column;
        }

        .section {
            width: 100%;
            display: flex;
            align-items: center;

            .order-panel-price-container {
                ${PriceCss}
            }
        }

        .section-middle {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            border-left: 2px solid ${({ theme }) => theme.colors.grey16};
            padding-left: 1rem;
            max-width: 50%;

            .section-middle-wrapper {
                width: 100%;

                .delivery {
                    font-size: ${({ theme }) => theme.fontSizes.textBase};
                    padding: ${rem(3)} ${rem(9)};
                    margin-bottom: ${rem(9)};
                    border-radius: ${rem('9px')};
                    background-color: #fff;
                    display: flex;
                    width: fit-content;
                }
            }

            @media screen and (max-width: ${breakpoints.lg}px) {
                min-width: 40%;
            }

            @media screen and (max-width: ${breakpoints.md}px) {
                display: none;
            }
        }

        .section-end {
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-left: 2px solid ${({ theme }) => theme.colors.grey16};
            padding-left: 1rem;
            .save-to-continue {
                display: none;

                @media screen and (max-width: ${breakpoints.md}px) {
                    margin-top: ${rem('20px')};
                    width: 100%;
                }

                @media screen and (min-width: ${breakpoints.md}px) {
                    display: block;
                }
            }

            div {
                width: fit-content;

                @media screen and (max-width: ${breakpoints.md}px) {
                    width: 100%;
                }
            }

            .desktopContactSection {
                @media screen and (max-width: ${breakpoints.lg}px) {
                    display: none;
                }
            }

            @media screen and (max-width: ${breakpoints.lg}px) {
                justify-content: flex-end;
            }

            @media screen and (max-width: ${breakpoints.sm}px) {
                justify-content: center;
            }

            @media screen and (max-width: ${breakpoints.lg}px) {
                min-width: 25%;
            }
        }

        @media screen and (max-width: ${breakpoints.md}px) {
            bottom: 0;

            .section-divider,
            .col-middle,
            .link {
                display: none;
            }
        }
    }

    .desktopContactSection {
        display: flex;
        justify-content: center;
        flex-direction: column;
        max-width: ${rem(230)};

        .modalLink {
            background: none;
            border: none;
            padding: 0;
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            color: ${({ theme }) => theme.colors.red};
            cursor: pointer;

            svg {
                margin-left: ${rem(10)};

                path {
                    fill: ${({ theme }) => theme.colors.red};
                    stroke: ${({ theme }) => theme.colors.red};
                }
            }

            &:hover,
            &:focus-visible {
                color: ${({ theme }) => theme.colors.grey5};

                svg {
                    path {
                        fill: ${({ theme }) => theme.colors.grey5};
                        stroke: ${({ theme }) => theme.colors.grey5};
                    }
                }
            }
        }

        .phoneLink {
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            color: ${({ theme }) => theme.colors.grey5};
            cursor: pointer;
            text-decoration: unset;
            padding-top: ${rem(10)};

            &:hover,
            &:focus-visible {
                text-decoration: underline;
            }
        }
    }

    .mobileContactSection {
        background: ${({ theme }) => theme.colors.blue2};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        color: ${({ theme }) => theme.colors.white};
        height: ${rem(40)};
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 ${rem(20)};
        cursor: pointer;

        @media (min-width: ${breakpoints.md}px) {
            display: none;
        }

        span {
            display: flex;
            align-items: center;

            svg {
                g {
                    path {
                        fill: ${({ theme }) => theme.colors.white} !important;
                    }
                }
            }
        }

        .label {
            svg {
                margin-left: ${rem(5)};
            }
        }

        .phone {
            svg {
                margin-right: ${rem(5)};
            }
        }
    }

    .benefitSection {
        padding: 0 ${rem(15)};
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        margin-top: ${rem(20)};

        .bullet-points {
            transform: scaleY(0);
            transform-origin: top;
            transition: transform 0.2s ease;
            height: 0;
            margin: 0;
            padding: 0 ${rem(5)};
        }

        .showBenefits {
            transform: scaleY(1);
            height: auto;
            margin: ${rem(12)} ${rem(12)} ${rem(12)} 0;
        }

        .allow-bullet-points {
            padding-left: ${rem(16)};
        }

        &.desktop {
            display: none;

            @media (min-width: ${breakpoints.md}px) {
                display: block;
                border-left: 2px solid ${({ theme }) => theme.colors.grey16};
                max-width: 50%;
                width: 100%;
            }
        }

        &.mobile {
            display: block;

            @media (min-width: ${breakpoints.md}px) {
                display: none;
            }
        }

        @media (min-width: ${breakpoints.md}px) {
            margin-top: 0;
        }

        .heading {
            text-transform: capitalize;
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            display: flex;
            align-items: center;
            cursor: pointer;

            &.isOpen {
                svg {
                    transform: rotate(-180deg);
                }
            }

            svg {
                margin-left: ${rem(10)};

                path {
                    fill: ${({ theme }) => theme.colors.black};
                }
            }
        }

        .bullet-points.disable-bullet-points {
            padding-left: 0;
            margin-top: 0;

            li {
                list-style: none;
            }
        }
    }
`;
